/**
 * Leitura mínima de `data/main` para o CRM (clientes estão no array `clients`, não numa coleção).
 */

import { assertCrmAccess } from './crmAccess.js';

/**
 * @param {string} clientId
 * @returns {Promise<boolean>} true se existe item em `data/main.clients` com o mesmo `id`
 * @throws {Error} se Firebase não permite verificar (falha técnica — não excluir por segurança)
 */
export async function clientExistsInDataMain(clientId) {
  const id = String(clientId || '').trim();
  if (!id) return false;
  assertCrmAccess();
  const database = window._fbDb;
  if (!database || typeof window._fbGetDoc !== 'function' || typeof window._fbDoc !== 'function') {
    throw new Error('Não foi possível verificar o cliente vinculado. Tente novamente.');
  }
  const mainRef = window._fbDoc(database, 'data', 'main');
  const mainSnap = await window._fbGetDoc(mainRef);
  if (!mainSnap.exists()) return false;
  const data = mainSnap.data() || {};
  const list = Array.isArray(data.clients) ? data.clients : [];
  return list.some(c => c && String(c.id || '') === id);
}
